import { MediaFile } from './vast/media-file';
import { excludedMimeType } from '../config';

export const OMID_VAST_URL_MACROS = [
  { key: 'OMIDPARTNER', value: 'ogury/1.0' },
  {
    key: 'APIFRAMEWORKS',
    value: '7'
  }
];

export const VPAID_VAST_URL_MACROS = [
  { key: 'OMIDPARTNER', value: 'ogury/1.0' },
  {
    key: 'APIFRAMEWORKS',
    value: '2'
  }
];

export const OMID_VPAID_VAST_URL_MACROS = [
  { key: 'OMIDPARTNER', value: 'ogury/1.0' },
  {
    key: 'APIFRAMEWORKS',
    value: '2,7'
  }
];

function excludeMimeType(mediaFiles: MediaFile[]): MediaFile[] {
  return (mediaFiles || []).filter(
    mediaFile =>
      !mediaFile.type ||
      excludedMimeType.indexOf(mediaFile.type.toLowerCase()) < 0
  );
}

function groupByMimeType(mediaFiles: MediaFile[]): MediaFile[][] {
  const groupedVideos = mediaFiles.reduce<Record<string, MediaFile[]>>(
    (res, mediaFile) => {
      res[mediaFile.type] = [...(res[mediaFile.type] || []), mediaFile];
      return res;
    },
    {}
  );

  return Object.keys(groupedVideos).map(type => groupedVideos[type]);
}

function filterByClosestAspectRatio(mediaFiles: MediaFile[]): MediaFile[] {
  const targetRatio = screen.width / screen.height;

  return mediaFiles
    .sort(
      (a, b) =>
        Math.abs(targetRatio - a.width / a.height) ||
        Infinity - Math.abs(targetRatio - b.width / b.height) ||
        Infinity
    )
    .filter(
      (mediaFile, i, sortedMediaFiles) =>
        sortedMediaFiles[0].width / sortedMediaFiles[0].height ||
        Infinity === mediaFile.width / mediaFile.height ||
        Infinity
    );
}

function filterByClosestResolution(
  mediaFiles: MediaFile[]
): MediaFile | undefined {
  return mediaFiles
    .sort(
      (a, b) =>
        Math.abs(screen.width - a.width) - Math.abs(screen.width - b.width)
    )
    .shift();
}

function sortBySdkPreferences(
  mediaFiles: (MediaFile | undefined)[]
): MediaFile[] {
  let mediaFileSorted = [...mediaFiles];

  // extract hls to put at the end of the array
  const extractHls: MediaFile[] = [];
  mediaFileSorted.forEach((a, i) => {
    if (a && a.type === 'application/x-mpegURL') {
      extractHls.push(a);
      delete mediaFileSorted[i];
    }
  });

  // clean undefined values
  mediaFileSorted = mediaFileSorted.filter(element => element !== undefined);

  // sort mp4 first
  mediaFileSorted.sort((a, b) => {
    if (!a || !b) return 0;
    if (a.type === b.type) {
      return 0;
    } else if (b.type === 'video/mp4') {
      return 1;
    } else {
      return -1;
    }
  });

  mediaFileSorted.push(...extractHls);
  return mediaFileSorted.filter((m): m is MediaFile => m !== undefined);
}

export function selectMediaFiles(mediaFiles: MediaFile[]): MediaFile[] {
  mediaFiles = excludeMimeType(mediaFiles);
  return sortBySdkPreferences(
    ([] as (MediaFile | undefined)[]).concat.apply(
      [],
      groupByMimeType(mediaFiles || [])
        .map(filterByClosestAspectRatio)
        .map(filterByClosestResolution)
    )
  );
}
